export const useResetMenuManagementState = () => {
  const trigger = () => {
    sessionStorage.removeItem('filters');
  };

  return [trigger];
};
